import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { Layout } from './components/layout/Layout';
import { Toaster } from './components/ui/sonner';

// Pages
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Vouchers from './pages/Vouchers';
import VoucherSuccess from './pages/VoucherSuccess';
import AdminVouchers from './pages/AdminVouchers';
import TemporarilyAway from './pages/TemporarilyAway';
import ChristmasSessions from './pages/ChristmasSessions';

// Vera is temporarily in the US for training — set to false to bring the site back online.
const SITE_TEMPORARILY_CLOSED = false;

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        {SITE_TEMPORARILY_CLOSED ? (
          <Routes>
            <Route path="/admin/vouchers" element={<AdminVouchers />} />
            <Route path="*" element={<TemporarilyAway />} />
          </Routes>
        ) : (
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/sessoes-de-natal" element={<ChristmasSessions />} />
              <Route path="/christmas-sessions" element={<ChristmasSessions />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/vouchers" element={<Vouchers />} />
              <Route path="/vouchers/success" element={<VoucherSuccess />} />
              <Route path="/admin/vouchers" element={<AdminVouchers />} />
            </Routes>
          </Layout>
        )}
        <Toaster />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
